import { DTypes as W, } from 'win32-def'
export { initialOpts, } from '@waiting/bankcard-reader-base'
export const config = {
    appDir: '',
}
export const dllFuncs = {
    star_InitConnect: [W.INT, [W.INT, W.INT, W.CHAR, W.CHAR, W.INT]],
    star_Open: [W.INT, [W.INT, W.INT, W.CHAR]],
    star_Close: [W.INT, []],
    star_GetDevInfo: [W.INT, [W.PSTR, W.LPINT]],
    star_ICGetInfo: [W.INT, [W.INT, W.PSTR, W.PSTR, W.INT]],
    star_ReadMagCardNo: [W.INT, [W.INT, W.INT, W.PSTR, W.LPINT, W.INT]],
}
